import { render, staticRenderFns } from "./PageReportItem.vue?vue&type=template&id=f6a2e53a&scoped=true&"
import script from "./PageReportItem.vue?vue&type=script&lang=js&"
export * from "./PageReportItem.vue?vue&type=script&lang=js&"
import style0 from "./PageReportItem.vue?vue&type=style&index=0&id=f6a2e53a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a2e53a",
  null
  
)

export default component.exports